/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    GetAllGroups,
    GetFactoriesByGroupID,
    GetFarmerWiseTransaction,
    GetFarmerByFactoryIDDropdown,
    CollectionCenterWiseTransaction
};

// async function GetProductCategoties() {
//     const response = await CommonGet('/api/ProductCategory/GetProductCategoryDetails', null);
//     return response.data;
// }

// async function GetProductDetails(productcatogeryID) {
//     const response = await CommonGet('/api/Product/GetAllProducts', 'productcatogeryID=' + parseInt(productcatogeryID));
//     return response.data;
// }

async function GetAllGroups() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

// async function GetProductsByFactoryIDProductcatogeryID(factoryID, productcatogeryID) {
//     const response = await CommonGet('/api/Product/GetProductsByFactoryIDProductcatogeryID', 'factoryID=' + parseInt(factoryID) + '&productcatogeryID=' + parseInt(productcatogeryID));
//     return response.data;
// }
async function GetFarmerByFactoryIDDropdown(factoryID) {
    const response = await CommonGet('/api/Farmer/GetFarmerDetailsByFactoryIDRouteID', 'factoryID=' + parseInt(factoryID) + '&routeID=' + parseInt(0));
    return response.data;
}

async function GetFarmerWiseTransaction(operationEntityID, farmerID, fromDate, toDate) {
    const response = await CommonGet('/api/FarmerWiseTransaction/GetFarmerWiseTransaction', 'operationEntityID=' + operationEntityID + '&farmerID=' + farmerID + '&fromDate=' + fromDate + '&toDate=' + toDate );
    return response.data;
}

async function CollectionCenterWiseTransaction(operationEntityID, fromDate, toDate){
    const response = await CommonGet('/api/FarmerWiseTransaction/GetAllFarmerWiseTransaction', 'operationEntityID=' + operationEntityID + '&fromDate=' + fromDate + '&toDate=' + toDate );
    return response.data;
}

